var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"content",staticClass:"flex flex-wrap items-stretch mt-9"},[_c('PublicationCard',{attrs:{"title":"Неоадъювантная и адъювантная терапия колоректального рака II стадии","expert":"Фамилия Имя","link":"publications/1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }